import { Group, Text, Badge, Button, Stack } from '@mantine/core';
import { IconLogout } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.jsx';

const ROLE_META = {
    creator: { label: 'Создатель', color: 'grape' },
    admin: { label: 'Админ', color: 'blue' },
    rop: { label: 'РОП', color: 'teal' },
    mop: { label: 'МОП', color: 'gray' },
};

export function UserBar() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    if (!user) return null;
    const roleMeta = ROLE_META[user.role] || { label: user.role, color: 'gray' };
    const displayName = user.fullName || user.username;

    const handleLogout = async () => {
        await logout();
        navigate('/login', { replace: true });
    };

    return (
        <Group gap="md" wrap="nowrap">
            <Stack gap={2} align="flex-end" visibleFrom="xs">
                <Text size="sm" fw={500} lh={1}>
                    {displayName}
                </Text>
                <Badge color={roleMeta.color} size="sm" variant="light">
                    {roleMeta.label}
                </Badge>
            </Stack>
            <Button
                variant="subtle"
                color="gray"
                size="xs"
                leftSection={<IconLogout size={16} />}
                onClick={handleLogout}
            >
                Выйти
            </Button>
        </Group>
    );
}
